import { localeToISO639Code } from "lib/i18n/localeToISO639Code";
import { OtherHealthConditions } from "lib/questionnaire/question-flows/onboarding/questions/otherHealthConditions";
import { Trans as TransQuestions } from "lib/questionnaire/question-flows/onboarding/questions/trans";
import { useLocale } from "render/context/InternationalizationContext";
import { TextInput } from "render/ui/presentation/Questionnaire/components/TextInput";
import { QuestionView } from "../../components/QuestionView";
import { Step, StepProps } from "../../step";
import { Trans } from "../../trans";

function OtherHealthConditionsStep({
  answers,
  onAnswer,
  onNext,
  onPrev,
  currentQuestion,
  totalQuestions,
  onResetAnswer,
}: StepProps) {
  const answer = answers.get(OtherHealthConditions);
  const label = TransQuestions.OtherHealthConditions.Question();
  const { englishLabel } = TransQuestions.OtherHealthConditions.Question;
  const locale = useLocale();
  const languageCode = localeToISO639Code(locale);

  return (
    <QuestionView
      currentQuestion={currentQuestion}
      totalQuestionCount={totalQuestions}
      question={OtherHealthConditions}
      onNext={onNext}
      onPrev={() => {
        onPrev();
        onResetAnswer(OtherHealthConditions);
      }}
      cta={<Trans.General.Continue />}
      explanation={{
        openText: <Trans.General.WhyAreWeAsking />,
        closeText: <Trans.General.OkIUnderstand />,
        explanationText: <Trans.Steps.OtherHealthConditionsExplanation />,
      }}
    >
      <TextInput
        placeholder={Trans.General.WriteYourAnswer()}
        answer={answer}
        onAnswer={(answer) => {
          onAnswer(OtherHealthConditions, {
            answer,
            questionAnswer: {
              questionId: "otherHealthConditions",
              englishLabel,
              label,
              languageCode,
              answer: {
                $type: "text",
                value: OtherHealthConditions.getValue(answer).trim(),
              },
            },
          });
        }}
      />
    </QuestionView>
  );
}

export function filter(steps: Step[]) {
  steps.push(OtherHealthConditionsStep);
}
